<div class="h-full flex flex-col w-full">
	<div class="flex justify-between mb-2 gap-2 items-end">
		<div class="flex justify-end mb-2 gap-2">
			<app-button
				btn="secondary"
				size="small"
				[icon]="ICON.PRINT"
				(click)="print()"
				[testHook]="testHooks.PrintButton"
				>Print</app-button
			>
			<app-button
				btn="secondary"
				size="small"
				[icon]="ICON.PDF"
				(click)="download()"
				[testHook]="testHooks.DownloadButton"
				>Download</app-button
			>
			<!-- <app-button *ngIf="expandable" btn="secondary" size="small" [icon]="ICON.EXPAND" (click)="openModal()">Expand</app-button> -->
		</div>
		<div class="flex" *ngIf="showCloseButton">
			<app-button
				btn="tertiary"
				[icon]="ICON.CLOSE"
				(click)="_onClose()"
				[testHook]="testHooks.CloseButton"
			></app-button>
		</div>
	</div>
	<app-pdftron
		class="min-h-0"
		#pdfViewer
		[fileName]="_fileName"
		[formData]="formData"
		[url]="url"
		(onFieldChanged)="fieldChanged($event)"
		(documentLoaded)="documentLoaded()"
		(finishedRendering)="_finishedRendering()"
	></app-pdftron>
</div>

<ng-template #buttons> </ng-template>
